/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Welcome_Map_DescriptionInputs */

const en_welcome_map_description = /** @type {(inputs: Welcome_Map_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick the simulation to load first. You can switch later from the HUD at any time.`)
};

const fr_welcome_map_description = /** @type {(inputs: Welcome_Map_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionnez la simulation à charger. Vous pourrez en changer à tout moment depuis le HUD.`)
};

const ms_sg2_welcome_map_description = /** @type {(inputs: Welcome_Map_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilih simulasi untuk dimuatkan dahulu. Anda boleh menukar kemudian dari HUD pada bila-bila masa.`)
};

/**
* | output |
* | --- |
* | "Pick the simulation to load first. You can switch later from the HUD at any time." |
*
* @param {Welcome_Map_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const welcome_map_description = /** @type {((inputs?: Welcome_Map_DescriptionInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Welcome_Map_DescriptionInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_welcome_map_description(inputs)
	if (locale === "fr") return fr_welcome_map_description(inputs)
	return ms_sg2_welcome_map_description(inputs)
});